const ApplicationNameEnum = {
  BEYOND_ASSETS: 'BEYOND_ASSETS' as 'BEYOND_ASSETS',
  BEYOND_APPROVAL: 'BEYOND_APPROVAL' as 'BEYOND_APPROVAL',
  BEYOND_BACK_OFFICE: 'BEYOND_BACK_OFFICE' as 'BEYOND_BACK_OFFICE',
  BEYOND_BETTING: 'BEYOND_BETTING' as 'BEYOND_BETTING',
  BEYOND_BUSINESS_SUITE: 'BEYOND_BUSINESS_SUITE' as 'BEYOND_BUSINESS_SUITE',
  BEYOND_CORE: 'BEYOND_CORE' as 'BEYOND_CORE',
  BEYOND_FINANCE: 'BEYOND_FINANCE' as 'BEYOND_FINANCE',
  BEYOND_IDENTITY: 'BEYOND_IDENTITY' as 'BEYOND_IDENTITY',
  BEYOND_INVENTORY: 'BEYOND_INVENTORY' as 'BEYOND_INVENTORY',
  BEYOND_MANUFACTURING: 'BEYOND_MANUFACTURING' as 'BEYOND_MANUFACTURING',
  BEYOND_MOBILE_TIME_MANAGEMENT: 'BEYOND_MOBILE_TIME_MANAGEMENT' as 'BEYOND_MOBILE_TIME_MANAGEMENT',
  BEYOND_MONITORING: 'BEYOND_MONITORING' as 'BEYOND_MONITORING',
  BEYOND_SALES: 'BEYOND_SALES' as 'BEYOND_SALES',
  BEYOND_PEOPLE: 'BEYOND_PEOPLE' as 'BEYOND_PEOPLE',
  BEYOND_POS: 'BEYOND_POS' as 'BEYOND_POS',
  BEYOND_PROCUREMENT: 'BEYOND_PROCUREMENT' as 'BEYOND_PROCUREMENT',
  BEYOND_RETAIL: 'BEYOND_RETAIL' as 'BEYOND_RETAIL',
  BEYOND_SMART_REPORTS: 'BEYOND_SMART_REPORTS' as 'BEYOND_SMART_REPORTS',
  DEX: 'DEX' as 'DEX',
  BEYOND_CORE_SETTINGS: 'BEYOND_CORE_SETTINGS' as 'BEYOND_CORE_SETTINGS',
};
type ApplicationNameEnum = (typeof ApplicationNameEnum)[keyof typeof ApplicationNameEnum];
export { ApplicationNameEnum };

